import React, { useState } from 'react';
import './Settings.css';

function Settings() {
  const [settings, setSettings] = useState({
    username: 'Enerji Kullanıcısı',
    email: 'user@enerjitakip.com',
    notifications: true,
    darkMode: false,
    language: 'tr',
    currency: 'TRY',
    energyUnit: 'kWh',
    pricePerUnit: 1.5,
    monthlyBudget: 1000,
    dailyGoal: 50
  });

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSave = () => {
    // Here you would typically save to a backend or localStorage
    localStorage.setItem('enerjiTakipSettings', JSON.stringify(settings));
    alert('Ayarlar kaydedildi!');
  };

  return (
    <div className="settings">
      <div className="settings-header">
        <h1>⚙️ Ayarlar</h1>
        <p>Uygulamanızı kişiselleştirin ve tercihlerinizi yönetin</p>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <h3>👤 Kullanıcı Bilgileri</h3>
          <div className="setting-group">
            <label>
              <span>Kullanıcı Adı</span>
              <input
                type="text"
                value={settings.username}
                onChange={(e) => handleSettingChange('username', e.target.value)}
              />
            </label>
            <label>
              <span>E-posta</span>
              <input
                type="email"
                value={settings.email}
                onChange={(e) => handleSettingChange('email', e.target.value)}
              />
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h3>🔔 Akıllı Alarm Sistemi</h3>
          <div className="setting-group">
            <label className="toggle-label">
              <span>E-posta bildirimleri</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifications}
                  onChange={(e) => handleSettingChange('notifications', e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>SMS bildirimleri</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Mobil push bildirimleri</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Kritik alarm bildirimleri</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={false}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
          </div>
        </div>
        
        <div className="settings-section">
          <h3>👥 Kullanıcı Yönetimi</h3>
          <div className="setting-group">
            <label className="toggle-label">
              <span>Rol bazlı yetkilendirme</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Departman bazlı erişim kontrolü</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Veri görünürlük sınırlandırması</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={false}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h3>🎨 Görünüm</h3>
          <div className="setting-group">
            <label>
              <span>Dil</span>
              <select
                value={settings.language}
                onChange={(e) => handleSettingChange('language', e.target.value)}
              >
                <option value="tr">Türkçe</option>
                <option value="en">English</option>
              </select>
            </label>
            <label className="toggle-label">
              <span>Karanlık Mod</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.darkMode}
                  onChange={(e) => handleSettingChange('darkMode', e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h3>⚡ Enerji Optimizasyonu</h3>
          <div className="setting-group">
            <label className="toggle-label">
              <span>Gerçek zamanlı izleme</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Otomatik kompanzasyon</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={false}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Talep kontrol sistemi</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
          </div>
        </div>
        
        <div className="settings-section">
          <h3>🔗 Entegrasyon Ayarları</h3>
          <div className="setting-group">
            <label className="toggle-label">
              <span>SCADA entegrasyonu</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>IoT cihaz entegrasyonu</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={true}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
            <label className="toggle-label">
              <span>Muhasebe sistemi bağlantısı</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={false}
                />
                <span className="toggle-slider"></span>
              </div>
            </label>
          </div>
        </div>
        
        <div className="settings-section">
          <h3>💰 Enerji Ayarları</h3>
          <div className="setting-group">
            <label>
              <span>Para Birimi</span>
              <select
                value={settings.currency}
                onChange={(e) => handleSettingChange('currency', e.target.value)}
              >
                <option value="TRY">₺ Türk Lirası</option>
                <option value="USD">$ Amerikan Doları</option>
                <option value="EUR">€ Euro</option>
              </select>
            </label>
            <label>
              <span>Enerji Birimi</span>
              <select
                value={settings.energyUnit}
                onChange={(e) => handleSettingChange('energyUnit', e.target.value)}
              >
                <option value="kWh">kWh</option>
                <option value="MWh">MWh</option>
                <option value="J">Joule</option>
              </select>
            </label>
            <label>
              <span>Birim Fiyat</span>
              <input
                type="number"
                step="0.01"
                value={settings.pricePerUnit}
                onChange={(e) => handleSettingChange('pricePerUnit', parseFloat(e.target.value))}
              />
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h3>🎯 Hedefler</h3>
          <div className="setting-group">
            <label>
              <span>Aylık Bütçe</span>
              <input
                type="number"
                value={settings.monthlyBudget}
                onChange={(e) => handleSettingChange('monthlyBudget', parseFloat(e.target.value))}
              />
            </label>
            <label>
              <span>Günlük Hedef</span>
              <input
                type="number"
                value={settings.dailyGoal}
                onChange={(e) => handleSettingChange('dailyGoal', parseFloat(e.target.value))}
              />
            </label>
          </div>
        </div>

        <div className="settings-actions">
          <button className="save-button" onClick={handleSave}>
            💾 Ayarları Kaydet
          </button>
          <button 
            className="reset-button"
            onClick={() => window.location.reload()}
          >
            🔄 Sıfırla
          </button>
        </div>
      </div>
    </div>
  );
}

export default Settings;
